import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { FAQS } from "../../data/faqs";
import { logAnalyticsEvent } from "../../Firebase";
import useSeo from "../../hooks/useSeo";
import "./Public.css";

export default function FaqHub() {
  const navigate = useNavigate();

  useSeo({
    title: "Roofing FAQ | Crowned Roofing Ontario",
    description:
      "Detailed roofing answers for Ontario property owners, including roof costs, repair versus replacement, inspections, insurance, and material comparisons.",
    ogImage: "https://www.crownedroofing.com/images/ogimg.png",
    canonical: "https://www.crownedroofing.com/faq",
  });

  const openFaq = (slug) => {
    logAnalyticsEvent("faq_open", {
      slug,
      source: "faq_hub",
    });
    navigate(`/faq/${slug}`);
  };

  return (
    <div className="faqPage">
      <Header />

      <section className="faqHero">
        <div className="faqContainer">
          <div className="faqHeroCard">
            <div className="faqEyebrow">Ontario Roofing FAQ</div>
            <h1>Detailed Answers to the Questions Homeowners Actually Ask</h1>
            <p>
              These are not one-line answers. Each topic is written to help Ontario property owners
              understand the decision behind the roofing question, not just the headline.
            </p>
          </div>
        </div>
      </section>

      <section className="faqHubSection">
        <div className="faqContainer">
          <div className="faqIntroGrid">
            <div>
              <h2 className="faqSectionTitle">Start With the Big Questions</h2>
              <p className="faqIntroText">
                Pricing, material choice, remaining service life, insurance, and repair-versus-replacement
                decisions all depend on context. Each page below goes deeper so visitors can move from
                uncertainty to a usable next step.
              </p>
            </div>

            <button
              type="button"
              className="faqPrimaryBtn"
              onClick={() => navigate("/contact")}
            >
              Request an Assessment
            </button>
          </div>

          <div className="faqGrid">
            {FAQS.map((faq) => (
              <article key={faq.slug} className="faqCard">
                <div className="faqCardCategory">{faq.category}</div>
                <h2>{faq.question}</h2>
                <p>{faq.description}</p>
                <button
                  type="button"
                  className="faqLinkBtn"
                  onClick={() => openFaq(faq.slug)}
                >
                  Read Full Answer
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
